import { Instagram, Facebook, Phone } from "lucide-react";

const Navbar = () => {
  return (
    <header className="bg-white shadow-md fixed w-full top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between relative">
        
        {/* LEWA: Social media */}
        <div className="flex gap-4 text-brandDark">
          <a href="https://www.instagram.com/jonglifta?igsh=eGx6Y3lsZGFobXZh" target="_blank" rel="noopener noreferrer" className="hover:text-brandGreen">
            <Instagram className="w-5 h-5" />
          </a>
          <a href="https://www.facebook.com/JONGLIFTA" target="_blank" rel="noopener noreferrer" className="hover:text-brandGreen">
            <Facebook className="w-5 h-5" />
          </a>
        </div>

        {/* ŚRODEK: Imię i nazwisko */}
        <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 text-xl font-bold text-brandDark">
        Bartosz Kostuj
        </div>

        {/* PRAWA: Nawigacja + tel */}
        <div className="flex items-center gap-6">
          <nav className="hidden md:flex gap-6 text-sm text-brandDark font-medium">
            <a href="#about" className="hover:text-brandGreen">O mnie</a>
            <a href="#pricing" className="hover:text-brandGreen">Cennik</a>
            <a href="#contact" className="hover:text-brandGreen">Kontakt</a>
          </nav>

          {/* Telefon z ikoną */}
          <a
            href="tel:+48739454709"
            className="flex items-center gap-2 bg-brandGreen text-white text-base px-4 py-2 rounded-md font-semibold hover:bg-brandGreenDark transition"
          >
            <Phone className="w-5 h-5" />
            739 454 709
          </a>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
